import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ThemeService } from '../services/theme.service';
// Import PrimeNG modules
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../services/permission.service';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { CarouselModule } from 'primeng/carousel';
import { LandingPageComponent } from '../landing-page/landing-page.component';
import { MessageService } from 'primeng/api';
import { UserEventHistoryService } from '../services/user-event-history.service';
// Interface for login data

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    CarouselModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ThemeService],
})
export class LoginComponent implements OnInit {
  // Current theme
  currentTheme: string = 'aura-then-theme';

  // Show/hide password toggle
  showPassword: boolean = false;

  // Form group for validation
  loginForm!: FormGroup;
  isLoading = false;

  constructor(
    private themeService: ThemeService,
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private permissionService: PermissionsService,
    private messageService: MessageService,
    private readonly userEventHistoryService: UserEventHistoryService
  ) {}

  ngOnInit(): void {
    // Initialize form with validators
    this.loginForm = this.fb.group({
      loginname: ['', Validators.required],
      password: ['', Validators.required],
    });

    // Subscribe to theme changes
    this.themeService.theme$.subscribe((theme: 'aura-then' | 'noir') => {
      this.currentTheme = `${theme}-theme`;
    });
  }

  // Toggle password visibility
  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  // Toggle between light and dark themes
  toggleTheme(): void {
    const currentTheme =
      this.currentTheme === 'aura-then-theme' ? 'aura-then' : 'noir';
    const newTheme = currentTheme === 'aura-then' ? 'noir' : 'aura-then';
    this.themeService.setTheme(newTheme);
  }

  // Form submission
  onSubmit(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      let pw = this.loginForm.get('password').value;
      const password = this.apiService.encrypt(pw, environment.SECRET_KEY);
      let payload = {
        loginname: this.loginForm.get('loginname').value,
        password: password,
      };
      this.apiService
        .loginAPI('/account/token', payload)
        .subscribe((response) => {
          this.isLoading = false;

          if(response.message)
            this.messageService.add({severity:'error', summary:'Error', detail:response.message || 'Invalid credentials'});
          sessionStorage.setItem('refresh', response.refresh);
          sessionStorage.setItem('access', response.access);
          sessionStorage.setItem('user_id', response.user_id);
          sessionStorage.setItem('user_role_id', response.user_role_id[0].id);
          sessionStorage.setItem(
            'user_role_name',
            response.user_role_id[0].name
          );
          sessionStorage.setItem(
            'user_role_code',
            response.user_role_id[0].code
          );
          sessionStorage.setItem('first_name', response.first_name);
          sessionStorage.setItem('last_name', response.last_name);
          sessionStorage.setItem('login_name', response.login_name);
          sessionStorage.setItem('rank_name', response.rank_name);
          sessionStorage.setItem('unit_name', response.unit_name);
          sessionStorage.setItem('unit_id', response.unit_id);
          this.userEventHistoryService.trackEvent(
            'LOGIN_SUCCESS',
            '/login',
            `Logged in as ${response.login_name || payload.loginname}`
          );
          this.router.navigate(['/dashboard']);
          if (response.access) {
            console.log('response access',response.access);
            
            // this.apiService.getAPI(`/access/get-permissions/?role_id=${response.user_role_id[0].id}`).subscribe((res: any) => {
            //     this.permissionService.setPermissions(res);

            //   });
          }else{
          this.isLoading = false;

            this.messageService.add({severity:'error', summary:'Error', detail:response.message || 'Invalid credentials'});
          }

          // Store the token expiration time (15 minutes from now)
          // this.setTokenRefreshTimer();
        });
    } else {
      // Mark all fields as touched to trigger validation messages
      this.loginForm.markAllAsTouched();
    }
  }
  // Assuming you store the time in sessionStorage or localStorage for persistence
  private tokenRefreshTimer: any; // To store the timer reference

  // Set up the periodic token refresh (every 12 minutes)
  private setTokenRefreshTimer(): void {
    const refreshTime = 10 * 60 * 1000; // 12 minutes in milliseconds
    // const refreshTime =  1000; // 12 minutes in milliseconds

    // Clear any existing timer to avoid duplicates
    if (this.tokenRefreshTimer) {
      clearTimeout(this.tokenRefreshTimer);
    }

    this.tokenRefreshTimer = setTimeout(() => {
      // this.refreshToken();
    }, refreshTime);
  }
  private refreshToken(): void {
    const refreshToken = sessionStorage.getItem('refresh');

    if (refreshToken) {
      const body = {
        refresh: refreshToken,
      };

      this.apiService.postAPI('/account/token/refresh/', body).subscribe(
        (response: any) => {
          // Update tokens in storage
          sessionStorage.setItem('refresh', response.refresh);
          sessionStorage.setItem('access', response.access);

          // Schedule the next refresh (every 12 minutes)
          this.setTokenRefreshTimer();
        },
        (error) => {
          console.error('Token refresh failed', error);
          this.router.navigate(['/login']);
        }
      );
    } else {
      this.router.navigate(['/login']);
    }
  }
}
